// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"183":"48de583c","488":"758bcb09","715":"364ab759","805":"714fe233"}[chunkId] + ".chunk.js";
};